var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sf-data-table',{ref:"PwaApcnTable",attrs:{"paging":"","pageUnit":_vm.pagingInfo.pageUnit,"totalSize":_vm.pagingInfo.totalSize,"columns":_vm.roApcnCols,"rows":_vm.rows,"stripe":false,"index":"","height":"650px"},on:{"changedPage":_vm.changedPage}})
}
var staticRenderFns = []

export { render, staticRenderFns }